import axios from '../utils/axios';

export default function addToJD(adminId, jobId, data) {
    return (
        axios.post('/admin/' + adminId + '/job/' + jobId + '/add-to-jd', data)
    )
}